import { Box, HStack, VStack, Text } from '@chakra-ui/react';
import { CheckMarkIcon } from 'assets/icons/v2';
import { NovaIcon } from 'components/ui/novaIcon';
import { VoucherFilterOptionProps } from '../types/FilterOption';

export const VoucherOption = ({
  label,
  date,
  allowedUsage,
  timesUsed = 0,
  onClick,
  isActive = false,
}: VoucherFilterOptionProps): React.ReactElement => {
  const isLimitReached = allowedUsage != null && allowedUsage > 0 && timesUsed >= allowedUsage;
  const isExpired = date && new Date(date) < new Date();

  return (
    <Box padding="15px" cursor="pointer" _hover={{ bg: 'background.canvas' }} onClick={onClick}>
      <HStack justify="flex-start" align="center">
        <Box boxSize="24px">
          {isActive && <NovaIcon icon={CheckMarkIcon} size="s" color="icon.accent" aria-hidden />}
        </Box>
        <VStack justify="center" align="flex-start" flex={1} gap="5px">
          <Text fontSize="body.m.medium" fontWeight="medium" color="text.primary">
            {label}
          </Text>
          {date && (
            <Text fontSize="body.s.regular" color="grey.500">
              {date}
            </Text>
          )}
        </VStack>
        {allowedUsage !== undefined && (
          <VStack align="flex-end" gap="3xs">
            <Text color={isLimitReached ? 'red.500' : 'grey.500'}>
              {timesUsed}/{allowedUsage}
            </Text>
            {isExpired && (
              <Text color="grey.500" fontSize="body.xs.regular">
                Abgelaufen
              </Text>
            )}
            {!isExpired && isLimitReached && (
              <Text color="red.500" fontSize="body.xs.regular">
                Limit erreicht
              </Text>
            )}
          </VStack>
        )}
      </HStack>
    </Box>
  );
};
